import "./AccountBriefComponent.scss";
import template from "./AccountBriefComponent.html";
import {IComponentOptions} from "angular";
import {AccountBriefRecord} from "../../types/AccountBriefRecord";

export const AccountBrief = "tfAccountBrief";

export function accountBrief(): IComponentOptions {
    return {
        template,
        bindings: {
            brief: "<"
        },
        controllerAs: "ctrl",
        controller: AccountBriefComponentController
    };
}

export class AccountBriefComponentController {

    public readonly brief: AccountBriefRecord;

}